import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Input, type InputProps } from 'base-ui'

import { i18nGetCurrencyForLocale, i18nGetCurrencySymbol } from '../../../i18n'

import styles from './ProductSearchRefinementPriceInput.module.css'

type ProductSearchRefinementPriceInputProps = Pick<
  InputProps,
  'className' | 'data-qa-id' | 'disabled' | 'onChange' | 'onKeyUp' | 'value'
>

export const ProductSearchRefinementPriceInput: FC<
  ProductSearchRefinementPriceInputProps
> = ({ 'data-qa-id': dataQaId, ...props }) => {
  const intl = useIntl()
  const currency = i18nGetCurrencyForLocale(intl.locale)
  const currencySymbol = i18nGetCurrencySymbol(currency, intl)

  return (
    <Input
      {...props}
      slotProps={{
        input: {
          className: clsx(
            styles['product-search-refinement-price-input__input'],
            'overflow-hidden text-ellipsis text-dark-primary-strong',
          ),
          'data-qa-id': dataQaId,
        },
        root: { className: 'pl-3 pr-3 gap-1' },
      }}
      startAdornment={currencySymbol}
      type="number"
    />
  )
}
